import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "token", "nodeFieldInput", "nodeManualSection", "segmentFieldInput", "segmentManualSection"]

  update() {
    const token = this.tokenTarget.value
    if (!token) return

    this.frameTargets.forEach(frame => {
      const url = new URL(frame.src, window.location.origin)
      url.searchParams.set("partner_token", token)
      frame.src = url.toString()
    })
  }

  onNodeModeChange(event) {
    this.applyModeChange(event, this.nodeFieldInputTarget, this.nodeManualSectionTarget)
  }

  onSegmentModeChange(event) {
    this.applyModeChange(event, this.segmentFieldInputTarget, this.segmentManualSectionTarget)
  }

  applyModeChange(event, fieldInput, manualSection) {
    const value = event.target.value
    if (value === "__other__") {
      fieldInput.value = ""
      manualSection.classList.remove("hidden")
      fieldInput.focus()
    } else {
      fieldInput.value = value
      manualSection.classList.add("hidden")
    }
  }
}
